import { render } from "./DashboardFooter.vue?vue&type=template&id=3ff357b6&scoped=true"
import script from "./DashboardFooter.vue?vue&type=script&lang=js"
export * from "./DashboardFooter.vue?vue&type=script&lang=js"

import "./DashboardFooter.vue?vue&type=style&index=0&id=3ff357b6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ff357b6"]])

export default __exports__